import md from '@/routes/middlewares';

import AcceptInvite from '@/views/nat/AcceptInvite.vue';
import AllSites from '@/views/sites/AllSites.vue';
import Clients from '@/views/clients/Clients.vue';
import Dashboard from '@/views/Dashboard.vue';
import Login from '@/views/Login.vue';
import Member from '@/views/member/Member.vue';
import MemberPage from '@/views/member/MemberPage.vue';
import NotFound404 from '@/views/NotFound404.vue';
import ProfilePage from '@/views/profile/ProfilePage.vue';
import CypressInitPage from '@/views/CypressInitPage.vue';
import ResetPassword from '@/views/nat/ResetPassword.vue';
import GptChat from '@/views/gpt/pages/GptChat.vue';
import SignupPage from '@/views/nat/SignupPage.vue';
import TeamPage from '@/views/TeamPage.vue';
import TrainingPage from '@/views/TrainingPage.vue';
import AppointmentPage from '@/views/calendar/AppointmentPage.vue';
import TeamsList from '@/views/TeamsList.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy';
import AlertsNotifications from '@/views/alerts/AlertsNotifications.vue';
import administration from './administration/administration';
import client from './client/client';
import laboratory from './laboratory/laboratory';
import services from './services/services';
import AdminProductPage from '../views/admin/configuration/AdminProductsPage.vue';

const routes = [
    services,
    administration,
    laboratory,
    client,
    {
        path: '/login',
        name: 'login',
        alias: '/',
        component: Login,
        meta: {
            middlewares: [md.accessControl, md.checkLogin],
        },
    },
    {
        path: '/privacypolicy',
        name: 'privacypolicy',
        alias: '/',
        component: PrivacyPolicy,
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            middlewares: [md.auth, md.accessControl, md.requiresSelectedTeam],
        },
    },
    {
        path: '/clients',
        name: 'clients',
        component: Clients,
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    {
        path: '/sites',
        name: 'allSites',
        component: AllSites,
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    {
        path: '/team',
        name: 'team',
        component: TeamPage,
        meta: {
            middlewares: [md.auth, md.requiresSelectedTeam],
        },
        children: [
            {
                path: 'roles',
                name: 'teamRoles',
                redirect: { name: 'team' },
                children: [
                    {
                        path: ':role',
                        name: 'teamRole',
                        component: TeamPage,
                    },
                ],
            },
        ],
    },
    {
        path: '/team/:memberId',
        component: MemberPage,
        redirect: { name: 'member' },
        meta: {
            middlewares: [md.auth, md.accessControl, md.getMemberInfo],
        },
        children: [
            {
                path: 'info',
                name: 'member',
                component: Member,
            },
        ],
    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfilePage,
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    {
        path: '/teams',
        name: 'teams',
        component: TeamsList,
        meta: {
            middlewares: [md.auth],
        },
    },
    {
        path: '/nat/passwordreset',
        name: 'PasswordReset',
        component: ResetPassword,
        meta: {
            middlewares: [md.dropTokens, md.decodeUrlResetPwdData],
        },
        props: route => ({
            code: route.query.url,
        }),
    },
    {
        path: '/nat/signup',
        name: 'signup',
        component: SignupPage,
        meta: {
            middlewares: [md.dropTokens, md.decodeURLSignUpData],
        },
        props: route => ({
            data: route.query.url,
        }),
    },
    {
        path: '/nat/acceptinvite',
        name: 'acceptInvite',
        component: AcceptInvite,
        meta: {
            middlewares: [md.dropTokens, md.decodeURLInviteData],
        },
        props: route => ({
            data: route.query.url,
        }),
    },
    {
        path: '*',
        name: 'allPages',
        beforeEnter: (to, from, next) => {
            const DISABLE_CYPRESS_FOR_CHAT = typeof window.Cypress === 'undefined';
            if (DISABLE_CYPRESS_FOR_CHAT) {
                if (!to.meta.retryCount) {
                // eslint-disable-next-line no-param-reassign
                    to.meta.retryCount = 1;
                } else {
                // eslint-disable-next-line no-param-reassign
                    to.meta.retryCount += 1;
                }
                if (to.path.startsWith('/administration/chatOptions')) {
                    const retryOrRedirect = () => {
                        if (to.meta.retryCount <= 5) {
                            setTimeout(() => next(to.fullPath), 250);
                        } else {
                            next('/404');
                        }
                    };
                    try {
                        retryOrRedirect();
                    } catch (error) {
                        console.error(`Loading attempt failed: ${error}`);
                        retryOrRedirect();
                    }
                } else {
                    next('/404');
                }
            } else {
                next('/404');
            }
        },
    },

    {
        path: '/404',
        name: 'notFound404',
        component: NotFound404,
    },
    {
        path: '/appointment',
        name: 'appointment',
        component: AppointmentPage,
        meta: {
            middlewares: [md.auth, md.getMemberInfo, md.accessControl],
        },
    },
    {
        path: '/alertsNotifications',
        name: 'alertsNotifications',
        component: AlertsNotifications,
        meta: {
            middlewares: [md.auth, md.getMemberInfo, md.accessControl],
        },
    },
    {
        path: '/training',
        name: 'training',
        component: TrainingPage,
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    {
        path: '/AdminProductsPage',
        name: 'productsPage',
        component: AdminProductPage,
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    {
        path: '/gpt-chat',
        name: 'gptChat',
        component: GptChat,
    },
    {
        path: '/cypress-init',
        name: 'cypressInit',
        component: CypressInitPage,
    },
];

export default routes;
